import { Header } from '@/components/Header';

export const testId = 'None';

export function None(): JSX.Element {
    return (
        <div data-testid={testId}>
            <Header />
        </div>
    );
}
